import HomeApp from "./_HomeApp";

const { $, EventEmitter } = window;

$(() => {
  const emitter = new EventEmitter();
  const promises = [];
  promises.push(HomeApp.load());
  Promise.all(promises).then(() => {
    window.app = new HomeApp(emitter);
  });
});
